export function getReservationAdvanceMinutes (settings) {
    const mins = parseInt(settings && settings.reserva_minutos_antes_notificacion, 10);
    return (isNaN(mins) || mins <= 0) ? 15 : mins;
}

export function reservationAdvanceAllowed (trip, settings) {
    if (!trip || !trip.es_con_reserva) return true;

    const pago = trip.pago_reserva || trip.pagoReserva;
    const paidOk = !!(pago && pago.status === 'approved');
    if (!paidOk) return false;

    const startAtMs = trip.fecha_hora_reserva ? new Date(trip.fecha_hora_reserva).getTime() : NaN;
    if (Number.isNaN(startAtMs)) return false;

    const advanceMs = getReservationAdvanceMinutes(settings) * 60 * 1000;
    return Date.now() >= (startAtMs - advanceMs);
}

export function canCancelReservation (item) {
    if (!item || !item.es_con_reserva) return false;
    const pago = item.pago_reserva || item.pagoReserva;
    if (pago && pago.status === 'cancelled') return false;
    if (pago && pago.status === 'approved') {
        return item.estado === 0 || item.estado === 1;
    }
    if (pago) {
        return pago.status === 'awaiting_driver' || pago.status === 'awaiting_payment';
    }
    return item.estado === 0 || item.estado === 1;
}

export function reservationAdvanceErrorMessage (trip) {
    if (!trip || !trip.es_con_reserva) return null;

    const pago = trip.pago_reserva || trip.pagoReserva;
    const paidOk = !!(pago && pago.status === 'approved');
    if (!paidOk) return 'Reserva pendiente de pago';

    return 'Reserva programada para el horario indicado';
}



// WEBPACK FOOTER //
// ./src/services/reservation.js